import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'
/**
 * @implements Service
 */
export class SaveNavigationDataSearchService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.localStorageRepository
   */
  constructor({config, localStorageRepository}) {
    super()

    this._config = config
    this._repository = localStorageRepository
  }

  /**
   * @return {Promise<Object, Error>} list of searches
   */
  @inlineError
  async execute(navigationRequestValueObject) {
    return this._repository
      .saveNavigationData(navigationRequestValueObject)
      .then(([saveNavigationDataError, saveNavigationDataResponse]) => {
        if (saveNavigationDataError) return Promise.reject(saveNavigationDataError)
        return saveNavigationDataResponse
      })
  }
}
